/*
ajax请求函数模块
返回值: promise对象(异步返回的数据是: response.data)
 */
// import $vue from '../main.js'
// import router from '../router'
import axios from 'axios'
import md5 from 'js-md5'
import store from './store';
import {
  url
} from './url';
export const BASE_URL = url;
const CancelToken = axios.CancelToken;
axios.interceptors.request.use(config => {
  // 这个是 取消重点
  config.cancelToken = new CancelToken((cancel) => {
    store._axiosPromiseCancel.push(cancel);
  });
  return config;
});
axios.interceptors.response.use(res => {
  return Promise.resolve(res)
  // do something...
}, error => {
  if (axios.isCancel(error)) {
    // 为了终结promise链 就是实际请求 不会走到.catch(rej=>{});这样就不会触发错误提示之类了。
    return new Promise(() => {});
  } else {
    return Promise.reject(error)
  }
});


export function reqExpost(method, url, params) {
  let timestamp = new Date().getTime().toString();
  let keys = Object.keys(params).sort(),
    i, length = keys.length,
    key, sortedString = '';
  for (i = 0; i < length; i++) {
    key = keys[i];
    sortedString += (key + '=' + params[key]);
  }
  let sign = md5(sortedString + 'yisuperiorToken');
  console.info(sign)
  return axios({
    method: method,
    url: url,
    headers: {
      token: sessionStorage.getItem('token') ? sessionStorage.getItem('token') : "",
      'Content-Type': 'application/json',
      timestamp: timestamp,
      'sign': sign
    },
    data: params,
    responseType: 'blob', // 表明返回服务器返回的数据类型
  }).then(res => res.data);
};






export default function ajax(url, data = {}, type = 'GET') {
  let constUrl = url;
  return new Promise(function(resolve, reject) {
    // 执行异步ajax请求
    let promise, params = {};
    //console.log("url..................aaa",url);
    //
    let getParams = function(locationsearch) {
      var search = locationsearch; //获取location的search属性，保存在search中
      var params = {}; //创建空对象params
      if (search != "") { //如果search不是空字符串
        search.slice(1).split("&").forEach( //?username=zhangdong&pwd=123456;//search去开头?，按&切割为数组，forEach
          function(val) {
            var arr = val.split("="); //将当前元素值按=切割，保存在arr中
            params[arr[0]] = arr[1]; //向params中添加一个元素,属性名为arr[0],值为arr[1]
          }
        );
      }
      return params; //返回params
    }

    // 准备url query参数数据
    let factoryId = sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')).id : false
    if (type == "GET") {
      if (Object.keys(data).length != 0) {
        // 准备url query参数数据
        let dataStr = '' // 数据拼接字符串
        Object.keys(data).forEach(key => {
          dataStr += key + '=' + data[key] + '&'
        })
        if (dataStr !== '') {
          dataStr = dataStr.substring(0, dataStr.lastIndexOf('&'))
          url = url + '?' + dataStr
          //console.log(url)
        }
        params = data;
      } else {
        if (url.indexOf("?") > -1) {
          params = getParams("?" + url.split("?")[1])
        } else {
          url = url + "?1=1";
          params = {
            1: 1
          };
        }
      }

    } else if (type == "POST") {
      if (Object.keys(data).length == 0) {
        data = {
          1: 1
        }
        params = {
          1: 1
        };
      } else {
        params = data
      }
    }



    ////////////


    // console.info("JSON.stringify(params).......................................................",JSON.stringify(params))//
    Object.keys(params).map((key) => {
      let values = params[key] // 获取到属性对应的值，做一些处理
      // console.info(values)
      if (values == null) {
        delete params[key];
      }

    })
    // console.info(JSON.stringify(params))
    let timestamp = new Date().getTime().toString();
    // let keys = Object.keys(params).sort(), i, length = keys.length, key, sortedString = '';
    // for (i = 0; i < length; i++) {
    //   key = keys[i];
    //   sortedString +=  (key + '=' + (Array.isArray(params[key]) ? JSON.stringify(params[key]) : params[key]));
    // }
    // console.log("sortedString...........",sortedString);
    // let sign = md5(sortedString + 'yisuperiorToken');
    // console.info("sign...........",sign)
    const sign = md5(sortObj(params) + 'yisuperiorToken');
    let headers;
    if (constUrl == `${BASE_URL}factory/login`) {
      headers = {

        timestamp: new Date().getTime(),
        sign
      }
    } else {
      headers = {
        token: sessionStorage.getItem('token') ? sessionStorage.getItem('token') : "",
        timestamp: new Date().getTime(),
        sign
      }
    }

    // console.log(headers)
    if (type === 'GET') {
      // 准备url query参数数据


      // 发送get请求
      promise = axios.get(url, {
        headers
      })
      // promise = axios.get(url)
    } else {
      // 发送post请求
      promise = axios.post(url, data, {
        headers
      })
      // promise = axios.post(url)
    }
    promise.then(function(response) {
      // 成功了调用resolve()
      // console.log("response.data....",response.data,router)

      if (response.data.code == 2) {
        // router.replace('/login')
      }
      resolve(response.data)
    }).catch(function(error) {
      // 失败了调用reject()
      // $vue.$message.error("请求失败");
      reject(error)
    })
  })
}

function sortObj(params) {
  let sortedStr = '';
  let keys = Object.keys(params).sort();
  for (let key of keys) {
    if (Array.isArray(params[key])) {
      if (Object.prototype.toString.call(params[key][0]) === '[object Object]') {
        for (let obj of params[key]) {
          sortedStr += (key + "=" + sortObj(obj));
        }
      } else {
        sortedStr += (key + "=" + JSON.stringify(params[key]));
      }
    } else {
      sortedStr += (key + "=" + params[key]);
    }
  }

  return sortedStr;
}
